import { api } from 'api'
import { ChargeAccount } from 'typings/common_defs'

type GetChargeAccountsResponse = null | {
  chargeAccounts: ChargeAccount[]
}

export async function getChargeAccounts() {
  const response = await api.post<GetChargeAccountsResponse>(
    '/company/graphql_dispatch/current_company_2cbd6697',
    {}
  )

  return response.data?.chargeAccounts || []
}

export async function getStripeACHUrl() {
  const response = await api.post<{ stripeAddAchUrl?: string }>(
    '/company/graphql_dispatch/stripe_ach_url_c57e4c8f',
    {}
  )
  return response.data.stripeAddAchUrl
}

export function uploadCardToken(cardToken: string, companyId: number) {
  return api.post(`/company/${companyId}/money/stripe_token`, {
    card_token: cardToken,
  })
}
